module.exports = __webpack_public_path__ + "static/media/licenta24.23b7d207.png";